import styled from "styled-components";

export const Wrapper = styled.div`
  @media (max-width: 1310px) {
    .ant-table-container {
      width: 1000px;
    }
  }
  @media (max-width: 690px) {
    .header {
      display: inline-block;
      padding: 20px;
      width: 100%;
    }
    .buttons {
      margin-top: 10px;
      display: inline-block;
      width: 100%;
    }
    .deleteButton {
      margin-left: 0px;
      margin-top: 10px;
    }
    .heading {
      text-align: center;
    }
  }
`;
